module.exports = __webpack_public_path__ + "static/media/cu.c56c1e92.svg";